import { useFormikContext } from "formik";
import InspectionRegister from "./field/InspectionRegister";
import { UnlinkVehicleFormValues } from "../EditUnlinkBond";

type Props = {
  onClose: () => void;
};

export default function UnlinkVehicleModal(props: Props) {
  const formik = useFormikContext<UnlinkVehicleFormValues>();

  return (
    <section className="flex flex-col gap-4">
      <InspectionRegister
        title="Inspeção Detalhada do Veículo"
        registers={formik.values.registers}
        onRemoveRegister={(index) =>
          formik.setFieldValue(
            "registers",
            formik.values.registers.filter((_, i) => i !== index)
          )
        }
        onCloseModal={props.onClose}
      />
    </section>
  );
}
